
import SectionOne from 'components/SectionOne';
// import SectionTwo from 'components/SectionTwo';
// import SectionThree from 'components/SectionThree';
import SectionFour from 'components/SectionFour';
import SectionFive from 'components/SectionFive';
import Footer from 'components/Footer';

import * as S from './App.styles';

function App() {
  return (
    <S.App>
      <SectionOne />
      {/* <SectionTwo /> */}
      {/* <SectionThree /> */}
      <SectionFour />
      <SectionFive />
      <Footer />
    </S.App>
  );
}

export default App;
